import { NavigatorUiLogger } from './logger';

type UiErrorLogger = Pick<NavigatorUiLogger, 'error'>;

export const globalErrorHandlersFor = (logger: UiErrorLogger) => ({
  error: (event: ErrorEvent): void => {
    logger.error('uncaught_error', event.error);
  },
  unhandledRejection: (event: PromiseRejectionEvent): void => {
    logger.error('unhandled_rejection', event.reason);
  },
});

export const registerGlobalErrorHandlers = (
  logger: UiErrorLogger,
): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const handlers = globalErrorHandlersFor(logger);
  window.addEventListener('error', handlers.error);
  window.addEventListener(
    'unhandledrejection',
    handlers.unhandledRejection,
  );
};
